import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getShopifyCart, updateSubmissionMethodForBase } from '@utils/shopify-helpers';
import TrashIconCart from '@components/cart/icons/TrashIconCart';
import LineIcon from '@components/cart/icons/LineIcon';
import { uploadPrescription } from '@services/cart';
import { PRODUCT_TYPES, RX_CELL_TYPES } from '@utils/enums';
import styles from './RxCell.module.scss';
import { setCartInfo } from '@features/cart/cartSlice';
let globalFileName = 'file uploaded';

const RxCell = ({ isRadio, title, label, subcopy, cellType, isSelected, item, setSelectedRx, bundleKey, setIsModalDisplayed }) => {
	const isPhoto = cellType === RX_CELL_TYPES.PHOTO;
	const dispatch = useDispatch();
	const inputRef = useRef();
	const [fileName, setFileName] = useState(isSelected ? globalFileName : '');
	const base = useSelector(state =>
		state.cart.items.find(item => item.product_type === PRODUCT_TYPES.BASE_FRAME && item.properties._bundle_key === bundleKey.toString())
	);

	const refreshCellSelection = async method => {
		const data = {
			id: base.key,
			properties: {
				...base.properties,
				_submissionMethod: method ?? RX_CELL_TYPES.REMIND,
			},
		};
		await updateSubmissionMethodForBase(data);
		const newCartData = await getShopifyCart('/');
		dispatch(setCartInfo(newCartData));
		setSelectedRx(method ?? cellType);
	};

	const handleCellClick = async () => {
		if (isSelected) {
			return;
		}

		if (isPhoto && inputRef.current) {
			inputRef.current.click();
			return;
		}

		if (cellType === RX_CELL_TYPES.DOCTOR) {
			setIsModalDisplayed(true);
			return;
		}

		await refreshCellSelection(cellType);
	};

	const deletePhoto = async () => {
		setFileName('');
		globalFileName = '';
		await refreshCellSelection(RX_CELL_TYPES.REMIND);
	};

	const handleFileUpload = async target => {
		const file = target.files[0];
		const data = new FormData();
		data.append('file', file);
		data.append('key', bundleKey);
		await uploadPrescription(data);
		setFileName(file.name);
		globalFileName = file.name;
		await refreshCellSelection(cellType);
	};

	return (
		<div
			data-prescription-selection={title}
			data-method={cellType}
			className={`cell ${cellType || ''} ${isSelected ? 'active' : ''}`}
			onClick={({ target }) => handleCellClick(target)}
		>
			{isPhoto && (
				<input
					ref={inputRef}
					type='file'
					name='prescription-photo'
					className='d-none'
					accept='image/*'
					onChange={({ target }) => {
						if (target.files.length) {
							handleFileUpload(target);
						}
					}}
				/>
			)}
			{isRadio && <div className={`radio-select ${isSelected ? 'active' : ''}`} />}
			<div className={`d-flex flex-column justify-content-start h-100 cell__copy ${styles.rxCell}`}>
				<h4 className='title h4'>{title}</h4>
				{label && <div className='button button-small blue-text'>{label}</div>}
				<div className='p'>{subcopy}</div>
				{isPhoto ? (
					<div className={`d-flex mt-2 ${styles.photoCell}`}>
						{isSelected && (
							<div id='fileName' className='p gray-text mw-50 text-truncate'>
								{fileName}
							</div>
						)}
						{isSelected && (
							<div className='d-flex flex-grow-0 flex-shrink-0 align-items-center'>
								<div className='uploadText p blue-text' onClick={() => {
									if (inputRef.current) inputRef.current.click();
								}}>Upload new</div>
								<LineIcon />
								<TrashIconCart onDelete={deletePhoto} />
							</div>
						)}
					</div>
				) : null}
			</div>
		</div>
	);
};

RxCell.propTypes = {
	isRadio: PropTypes.bool,
	title: PropTypes.string,
	label: PropTypes.string,
	subcopy: PropTypes.string,
	cellType: PropTypes.string,
	bundleKey: PropTypes.string,
	isSelected: PropTypes.bool,
	setSelectedRx: PropTypes.func,
	setIsModalDisplayed: PropTypes.func,
};

export default RxCell;
